import { Divider, Skeleton } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const IconCard = ({ card: { label, icon, add, value }, isLoading }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);

  if (isLoading) {
    return (
      <div
        className="shadow-md h-48 rounded-xl p-4 flex flex-col justify-between"
        style={{ minWidth: "16rem", maxWidth: "30rem" }}
      >
        <Skeleton variant="text" height={45} />

        <div className="flex justify-between items-center space-x-4">
          <div className="flex items-center space-x-8">
            <Skeleton variant="circular" width={70} height={70} />
            <Skeleton variant="text" width={100} height={45} />
          </div>
        </div>
        <div>
          <Divider />
          <Skeleton variant="text" height={25} />
        </div>
      </div>
    );
  }

  return (
    <div
      className="shadow-md w-full h-48 rounded-xl p-3"
      style={{ minWidth: "16rem", maxWidth: "30rem" }}
    >
      <p className="text-2xl font-bold m-0">{label}</p>
      <div className="flex justify-around items-center py-3">
        {icon}
        <p className="text-4xl font-bold m-0" style={{ color: colorPrimary }}>
          {value}
        </p>
      </div>
      <div>
        <Divider />
        <p className="font-bold m-0 p-1 text-md">
          Nuovi:
          <span
            style={{ color: colorSecondary }}
            className="font-bold m-0 p-1 text-lg"
          >
            {add}
          </span>
        </p>
      </div>
    </div>
  );
};

export default IconCard;
